import React from 'react';
import PropTypes from 'prop-types';

import { SUBSCRIPTION_TYPES } from '../../../constants/subscriptions';

/**
 * MobileComparisonTable component displays a mobile-optimized comparison
 * of features available in standard vs elevated profiles
 *
 * @param {Object} props
 * @param {ReadonlyArray<import('../constants').ComparisonFeature>} props.features - Array of features to compare
 * @param {string} [props.className] - Additional CSS classes
 */
const MobileComparisonTable = ({ features = [], className = '' }) => {
  return (
    <div
      className={`flex flex-col w-full md:hidden bg-white z-10 rounded-lg ${className}`}
    >
      {/* Header */}
      <div className="flex items-center">
        <div className="flex justify-center items-center w-1/2 p-3 text-gray-90 bg-gray-20 text-sm font-semibold leading-5 rounded-tl-lg">
          STANDARD
        </div>
        <div className="flex justify-center items-center w-1/2 p-3 text-white bg-linear-to-r from-blue-50 to-blue-30 text-sm font-semibold leading-5 rounded-tr-lg">
          ELEVATED
        </div>
      </div>

      {/* Price Row */}
      <div className="flex h-10 py-2 justify-center items-center border-b border-gray-20 text-deep-blue-70 text-sm font-semibold leading-5">
        Price
      </div>
      <div className="flex items-center h-[90px]">
        <div className="flex justify-center items-center text-base w-1/2 font-semibold">
          $0
        </div>
        <div className="flex flex-col justify-center items-center gap-2 w-1/2 border-l border-blue-30 h-full">
          <div className="flex items-center gap-1">
            <span className="text-gray-90 text-base font-semibold">
              {SUBSCRIPTION_TYPES.MONTHLY.displayPrice}
            </span>
            <span className="text-gray-90 text-sm font-normal leading-5 whitespace-nowrap">
              monthly
            </span>
          </div>
          <div className="w-10 h-[2px] bg-gray-20" />
          <div className="flex items-center gap-1">
            <span className="text-gray-90 text-base font-semibold">
              {SUBSCRIPTION_TYPES.ANNUAL.displayPrice}
            </span>
            <span className="text-gray-90 text-sm font-normal leading-5 whitespace-nowrap">
              annually
            </span>
          </div>
        </div>
      </div>

      {/* Feature Rows */}
      {features.map((item) => (
        <React.Fragment key={item.feature}>
          <div className="flex h-10 py-2 justify-center items-center border-b border-t border-gray-20 text-deep-blue-70 text-sm font-semibold leading-5">
            {item.feature}
          </div>
          <div className="flex items-center">
            <div className="flex justify-center items-center text-base w-1/2 font-semibold p-4">
              {item.standard ? (
                <img
                  src="/public/images/check-icon.svg"
                  alt="check-icon"
                  className="w-5 h-5 text-blue-30"
                />
              ) : (
                <span className="text-deep-blue-70 text-center text-xl font-light leading-5">
                  -
                </span>
              )}
            </div>
            <div className="flex justify-center items-center w-1/2 border-l border-blue-30 h-full p-4">
              {item.elevated ? (
                <img
                  src="/public/images/check-icon.svg"
                  alt="check-icon"
                  className="w-5 h-5 text-blue-30"
                />
              ) : (
                <span className="text-deep-blue-70 text-center text-xl font-light leading-5">
                  -
                </span>
              )}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

MobileComparisonTable.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      feature: PropTypes.string.isRequired,
      standard: PropTypes.bool.isRequired,
      elevated: PropTypes.bool.isRequired,
    }),
  ),
  className: PropTypes.string,
};

export default MobileComparisonTable;
